export function koreanMonth(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit' }).formatToParts(date);
    return parts.find(part => part.type === 'year').value + '-' + parts.find(part => part.type === 'month').value;
}

export function validPaymentMonth(value) {
    return typeof value === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
}

export function isMemberPaid(member) {
    return !!member.paid;
}

export function markMembersUnpaid(records) {
    if (!records || typeof records !== 'object') return;
    const result = { ...records };
    Object.entries(records).forEach(([key, member]) => {
        if (key !== 'signUp_exemptCount' && member && typeof member === 'object') {
            result[key] = { ...member, paid: false };
        }
    });
    return result;
}
